import { render, staticRenderFns } from "./SlaveWidget.vue?vue&type=template&id=5990f1e4&scoped=true&"
import script from "./SlaveWidget.vue?vue&type=script&lang=js&"
export * from "./SlaveWidget.vue?vue&type=script&lang=js&"
import style0 from "./SlaveWidget.vue?vue&type=style&index=0&id=5990f1e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5990f1e4",
  null
  
)

export default component.exports